import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { customErrorSchema } from "~/common/types";
import { sendVerificationCode } from "~/providers/api/verificationCode";

export const useSendVerificationCode = () => {
  return useMutation({
    mutationFn: sendVerificationCode,
    onError: (error) => {
      const result = customErrorSchema.safeParse(error);
      if (result.success) {
        toast.error(result.data.response.data.detail);
      }
    },
  });
};
